import $ from 'jquery';

import Error from './error';
import Confirmer from './confirm';

import ApplicationFormBase from './application-form-base';

export default class FormGenerator {

	constructor() {


		if ($("#form-generator").length > 0) {
			try {
				this.init(window.__form_generator);
			} catch(ex) {
				// form not found...
			}

		}

	}

	init(data) {

        let dataObject = {
            form: data
        };

        Vue.component('form-generator', () => import('../components/FormGenerator.vue'));

        this.vm = new Vue({
            template: '<form-generator :form="form"></form-generator>',
            el: "#form-generator",
            data: dataObject,
            methods: {

            }
        });

        $("#form-save").click(e => {

            $.ajax({
                data:{
                    op: "saveEditForm",
                    data: JSON.stringify(dataObject.form),
                    slug: window.formDataSlug
                },
                success: (d, s) => {
                    alert("Translations Saved")
                }
            });

        })

	}


}
